import { ArrowLeft, Edit3, MoreHorizontal, PackagePlus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { AuthButton } from '@/core/permissions/AuthButton';
import type { InventoryDetailItem } from '../types/inventoryDetail.types';

interface InventoryDetailHeaderProps {
  item: InventoryDetailItem;
  canUpdate: boolean;
}

export function InventoryDetailHeader({ item, canUpdate }: InventoryDetailHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-md border border-slate-200 bg-white p-3 shadow-sm">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={() => navigate('/inventory/items')}
          className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
        </button>
        <div className="hidden sm:block">
          <h1 className="sm:text-sm text-xs text-slate-900 leading-none font-semibold">Chi tiết vật tư</h1>
          <p className="text-[10px] text-slate-500 mt-1 tracking-wider uppercase">ID: {item.id.slice(0, 8)}</p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <button type="button" className="inline-flex h-10 items-center justify-center gap-2 rounded-md border border-slate-200 bg-white px-3 sm:text-sm text-xs text-slate-700 hover:bg-slate-50 transition-colors">
          <MoreHorizontal className="h-4 w-4" />
          <span className="hidden sm:inline">Khác</span>
        </button>
        
        <AuthButton
          module="inventory.items"
          action="update"
          behavior="hide"
          type="button"
          onClick={() => navigate(`/inventory/items/edit/${item.id}`)}
          className="inline-flex h-10 items-center justify-center gap-2 rounded-md border border-slate-200 bg-white px-4 sm:text-sm text-xs text-slate-700 hover:bg-slate-50 transition-colors"
        >
          <Edit3 className="h-4 w-4" />
          Chỉnh sửa
        </AuthButton>

        <button
          type="button"
          onClick={() => navigate(`/inventory/receipts/${item.id}`)}
          className="inline-flex h-10 items-center justify-center gap-2 rounded-md bg-emerald-700 px-4 sm:text-sm text-xs text-white hover:bg-emerald-800 transition-colors border-none shadow-sm shadow-emerald-200"
        >
          <PackagePlus className="h-4 w-4" />
          Nhập vật tư
        </button>
      </div>
    </div>
  );
}
